import { useEffect } from "react";
import Button from "../Button/Button";
import style from "./ErrorScreen.module.css";

export default function ErrorScreen() {
  useEffect(() => {
    document.title = "Job Details | Error";
  }, []);

  return (
    <div className={style.container}>
      <div className={style.title}>Something went wrong</div>
      <div className={style.content}>
        <div className={style.buttonContainer}>
          <Button
            variant="secondary"
            onClick={() =>
              (window.location.href = "https://www.shapr3d.com/careers")
            }
          >
            View other jobs at Shapr3D
          </Button>
        </div>
      </div>
    </div>
  );
}
